import React from 'react';
import FormModal from '../../../../Presentation/components/common/FormModal';
import FormField from '../../../../Presentation/components/common/FormField';
import {useFormState} from '../../../../Presentation/utils/formUtils';
import {useUpdateCreditLimit} from '../../../credit/hooks/useUpdateCreditLimit';
import {useNotification} from '../../../../Services/useNotification';
import {CommonValidationRules} from '../../../../Presentation/utils/formUtils';

interface EditCreditLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  storeId: number;
  currentCreditLimit: number;
  onSuccess: () => void;
}

export const EditCreditLimitModal: React.FC<EditCreditLimitModalProps> = ({
  isOpen,
  onClose,
  storeId,
  currentCreditLimit,
  onSuccess
}) => {
  const {updateCreditLimit, loading} = useUpdateCreditLimit();
  const notification = useNotification();

  const [formState, formActions] = useFormState<{ credit_limit: number | string; reason: string }>(
    {
      credit_limit: currentCreditLimit,
      reason: ''
    },
    {
      credit_limit: {
        ...CommonValidationRules.required('حد الائتمان'),
        customValidator: (value: any) => {
          const num = Number(value);
          if (value === '' || value === null || value === undefined) {
            return 'حد الائتمان مطلوب';
          }
          if (isNaN(num)) {
            return 'يجب أن يكون حد الائتمان رقماً صحيحاً';
          }
          if (num < 0) {
            return 'يجب أن يكون حد الائتمان أكبر من أو يساوي صفر';
          }
          return null;
        }
      }
    }
  );

  const handleSubmit = async () => {
    await formActions.submit(async (data) => {
      try {
        // Convert credit_limit to number before submitting
        const creditLimit = typeof data.credit_limit === 'string' 
          ? Number(data.credit_limit) 
          : data.credit_limit;
        
        await updateCreditLimit(storeId, {
          credit_limit: creditLimit,
          reason: data.reason || undefined
        });
        notification.success('تم تحديث حد الائتمان بنجاح');
        onSuccess();
        onClose();
      } catch (error: any) {
        notification.error(error.message || 'حدث خطأ أثناء تحديث حد الائتمان');
      }
    });
  };

  return (
    <FormModal
      open={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="تعديل الحد الائتماني"
      isLoading={loading || formState.isSubmitting}
      disabled={loading || formState.isSubmitting}
      width="max-w-md"
    >
      <FormField
        type="number"
        label="حد الائتمان"
        value={formState.data.credit_limit}
        onChange={(valueOrEvent) => {
          // AppInput passes React event object (e.target.value)
          // Extract the value from event if it's an event object
          const rawValue = typeof valueOrEvent === 'object' && valueOrEvent?.target?.value !== undefined
            ? valueOrEvent.target.value
            : valueOrEvent;
          
          // Keep as string while typing to prevent input from disappearing
          // Convert to number only on submit
          const stringValue = rawValue === null || rawValue === undefined ? '' : String(rawValue);
          formActions.setField('credit_limit', stringValue);
        }}
        error={formState.errors.credit_limit}
        min={0}
        step={1}
        autoFocus
      />

      <FormField
        type="textarea"
        label="السبب (اختياري)"
        value={formState.data.reason}
        onChange={(value) => formActions.setField('reason', value)}
        error={formState.errors.reason}
        rows={3}
        placeholder="أدخل سبب تعديل حد الائتمان..."
      />
    </FormModal>
  );
};
